import { Progress } from "@/components-shared/ui/progress";

type Props = {
  name: string;
  rate: number;
};

const FeedbackElement = ({ name, rate }: Props) => {
  return (
    <div className="grid grid-cols-10 items-center gap-2">
      <p className="col-span-3 text-sm">{name}</p>
      <Progress value={rate * 10} className="col-span-6" />
      <span className="text-gray-dark text-sm font-semibold">
        {rate ? rate : ""}
      </span>
    </div>
  );
};

export default FeedbackElement;
